var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['tva-image-lazy', _vm.config.imageSize]},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(("" + _vm.baseUrl + (_vm.content.src))),expression:"`${baseUrl}${content.src}`"}]})])}
var staticRenderFns = []

export { render, staticRenderFns }